import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const SetAsPrimaryModal = ({
  applicantName,
  applicantId,
  applicationId,
  onClose,
  onSuccess
}: {
  applicantName: string;
  applicantId: string;
  applicationId: string;
  onClose: () => void;
  onSuccess?: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationKey: ["APPLICANTS", applicationId, applicantId, "SET_PRIMARY"],
    mutationFn: () =>
      instance.post(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/set_as_primary`
      ),
    onSuccess: () => {
      toast.success("Primary applicant updated successfully");
      onSuccess?.();
      onClose();
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <ConfirmDialog
      opened
      onClose={onClose}
      onConfirm={() => mutate()}
      title="Update role to primary applicant?"
      description={`${applicantName} will be set as the primary applicant for the group application`}
      variant="base"
      icon={{ icon: InformationCircleIcon, variant: "base" }}
      confirmButton={{ label: "Update", loading: isPending }}
      cancelButton={{ label: "Cancel", disabled: isPending }}
    />
  );
};
